import { Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { STORAGE_URL } from "constants";
import { useLanguage } from "hooks";
import { Icons, Skeletons } from "components";

function About() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { facts } = useSelector((state) => state.app); // call data from app store

  return (
    <section className="mb-3 about_us">
      <Container>
        {/* about us header */}
        <Row className="mb-4">
          <Col xl={4} lg={3} md={3} sm={0} xs={0}></Col>
          <Col xl={8} lg={9} md={9} sm={0} xs={0}>
            <h2 className="fw-bold text-primary text-center">
              {language.learnAboutUS}
            </h2>
          </Col>
        </Row>

        {/* about us main */}
        <Row className="align-items-xl-center">
          <Col xl={4} lg={4} md={4} sm={0} xs={12}>
            {/* about us panels list */}
            <Row className="justify-content-start">
              <Col xs={12} className="mb-2">
                <NavLink
                  to="/search"
                  className="d-flex align-items-center px-3 bg-light rounded-1 panel"
                >
                  <Icons.Search className="svg-fill-primary" />

                  <p className="fw-bold text-black w-100 py-2 mx-4">
                    {language.searchLibrary}
                  </p>
                  <Icons.VectorLeft />
                </NavLink>
              </Col>
              <Col xs={12} className="mb-2">
                <NavLink
                  to="/InfoTypes"
                  className="d-flex align-items-center px-3 bg-light rounded-1 panel"
                >
                  <Icons.BookMark className="svg-fill-primary" small={"true"} />

                  <p className="fw-bold text-black w-100 py-2 mx-4">
                    {language.reserveABook}
                  </p>
                  <Icons.VectorLeft />
                </NavLink>
              </Col>
              <Col xs={12}>
                <NavLink
                  to="/InfoTypes"
                  className="d-flex align-items-center px-3 bg-light rounded-1 panel"
                >
                  <Icons.Book className="svg-fill-primary" />
                  <p className="fw-bold text-black w-100 py-2 mx-4">
                    {language.browseBooks}
                  </p>
                  <Icons.VectorLeft />
                </NavLink>
              </Col>
            </Row>
          </Col>

          <Col xl={8} lg={8} md={8} sm={0} xs={12}>
            {/* about us cards map */}
            {facts.loading ? (
              <Skeletons.AboutCardsSkeleton />
            ) : (
              facts.data.length > 0 && (
                <Row className="justify-content-center mt-4 mt-md-0">
                  {facts.data.map((item) => (
                    <Col
                      key={item.id}
                      xl={3}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="p-0"
                    >
                      {/* about us card */}
                      <div
                        className={`mx-1 mb-2 about_us_card bg-white border border-light3 border-2 rounded-3 py-4`}
                      >
                        <Row>
                          {/* about us card image */}
                          <Col xs={12} className="text-center">
                            {item.icon && (
                              <img
                                src={`${STORAGE_URL}${item.icon}`}
                                width={60}
                                height={60}
                                className="mw-100"
                                alt={item.name}
                              />
                            )}
                          </Col>
                          <Col xs={12} className="text-center mt-2">
                            {/* about us card number*/}
                            <h2 className="fw-bold text-light3">
                              {item.number}
                            </h2>
                          </Col>
                          <Col xs={12} className="text-center">
                            {/* about us card name/title*/}
                            <h6 className="fw-bold text-primary">
                              {item.name}
                            </h6>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </Row>
              )
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
